<script setup>
import { ref } from 'vue';

defineProps({
    titulo: {
        type: String
    },
    descricao: {
        type: String,
        default: ''
    },
    labelBotaoConfirmar: {
        type: String,
        default: 'Confirmar'
    },
    visibleBotaoConfirmar: {
        type: Boolean,
        default: true
    },
    labelBotaoCancelar: {
        type: String,
        default: 'Cancelar'
    },
    severidadeBotaoConfirmar: {
        type: String,
        default: 'success'
    },
    largura: {
        type: String,
        default: '65vw'
    },
    breakpoints: {
        type: Object,
        default: () => ({ '960px': '90vw', '640px': '95vw' })
    },
    loading: {
        type: Boolean,
        default: false
    },
    carregamentoSubmit: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['fechar', 'submeter']);

const visible = ref(true);

const handleSubmit = (event) => {
    emit('submeter', event);
};

const handleFechar = () => {
    visible.value = false;
    emit('fechar');
};

const handleAfterHide = () => {
    visible.value = false;
    emit('fechar');
};
</script>

<template>
    <Dialog :visible="visible" :closable="false" appendTo="body" modal :style="{ width: largura }"
        :breakpoints="breakpoints" :draggable="false" :resizable="false" @after-hide="handleAfterHide" :pt="{
            header: { class: 'pb-0' },
            footer: { class: 'px-4 lg:px-5 pt-4' },
            content: { class: 'px-5 pt-3 surface-card' },
        }">

        <form @submit.prevent="handleSubmit" class="surface-card">
            <div class="grid formgrid p-fluid flex justify-content-between mb-3 gap-3 lg:gap-0">
                <div class="col-12 lg:col-4 relative">
                    <CabecalhoListas :titulo="titulo" :descricao="descricao" class="sticky top-0">
                        <template v-if="$slots.descricao" #descricao>
                            <slot name="descricao"></slot>
                        </template>
                    </CabecalhoListas>
                </div>

                <!-- Conteúdo do formulário customizado via slot -->
                <Carregador v-if="$slots.form" :carregando="loading"
                    class="grid formgrid p-fluid coluna-form col-12 lg:col-7 mt-5">
                    <div class="grid formgrid p-fluid coluna-form col-12 lg:col-7">
                        <slot name="form"></slot>
                    </div>
                </Carregador>
            </div>
        </form>

        <template #footer>
            <div class="flex flex-row w-full" :class="$slots.botaoesquerdo ? 'justify-content-between' : 'justify-content-end'">
                <slot name="botaoesquerdo" v-if="$slots.botaoesquerdo"></slot>

                <div class="flex gap-3 justify-content-end">
                    <Button :label="labelBotaoCancelar" @click="handleFechar" size="small" severity="secondary" text
                    :disabled="carregamentoSubmit"></Button>
                    <Button v-if="visibleBotaoConfirmar" data-tour="dialogo-confirmar" @click="handleSubmit" :severity="severidadeBotaoConfirmar" size="small"
                    :label="labelBotaoConfirmar" class="p-button-rounded" :loading="carregamentoSubmit"
                    :disabled="carregamentoSubmit"></Button>
                </div>
            </div>
        </template>
    </Dialog>
</template>

<style scoped>
/* A coluna é .grid e .col-* ao mesmo tempo: como o .col-* já fixa width: 100%, a margem negativa
   do .grid não alarga a caixa, apenas desloca o bloco 0.5rem para a esquerda, sobrando espaço na
   lateral direita. No desktop isso passa despercebido; no mobile, onde a coluna ocupa a largura
   toda, a assimetria fica visível — então lá as margens laterais são zeradas. */
@media (width < 768px) {
    .coluna-form {
        margin-left: 0;
        margin-right: 0;
    }
}
</style>
